import { window } from "global";
import React, { useState, useRef } from "react";
import { useMutation } from "@apollo/client";
import CustomInput from "components/CustomInput";
import ButtonSuccess from "components/Buttons/ButtonSuccess";
import { DELETE_ACCOUNT } from "@ugg/shared/api/graphql/queries";
import { removeCookie } from "@ugg/shared/utils/cookies";
import FeedbackForm from "components/Masthead/Feedback/FeedbackForm";
import { HeaderBullet } from "@ugg/shared/components/common/HeaderBullet";

const DeleteAccount = (props) => {
  const [formOpen, setFormOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [deleteError, setDeleteError] = useState("");

  const [feedbackState, setFeedbackPopup] = useState(false);
  const toggleFeedbackPopup = () => {
    setFeedbackPopup(!feedbackState);
  };

  const onCompleted = (data) => {
    if (data.deleteUser.success) {
      if (window) {
        removeCookie("authToken");
        // localStorage.removeItem("authToken");
        window.location.href = "/";
      }
    }
  };

  const onError = (mutationError) => {
    const error = JSON.parse(JSON.stringify(mutationError));
    const { graphQLErrors } = error;

    setEmail("");
    setEmailError("");
    setPassword("");
    setPasswordError("");

    if (graphQLErrors[0].message === "unauthorized") {
      setDeleteError("Incorrect email/password");
    } else if (graphQLErrors[0].message === "active_uncanceled_premium") {
      setDeleteError("Please cancel your active U.GG Plus subscription before deleting your account.");
    } else {
      setDeleteError("An error occurred. Please try again.");
    }
  };

  const verifyForm = () => {
    let hasError = false;

    // Email
    if (email.trim().length === 0) {
      hasError = true;
      setEmailError("Missing email");
    } else {
      setEmailError("");
    }

    // Password
    if (password.length === 0) {
      hasError = true;
      setPasswordError("Missing password");
    } else {
      setPasswordError("");
    }

    if (!hasError) {
      deleteAccount();
    }
  };

  const resetValues = () => {
    setFormOpen(false);
    setEmail("");
    setEmailError("");
    setPassword("");
    setPasswordError("");
    setDeleteError("");
  };

  const [deleteAccount, { loading, data, error }] = useMutation(DELETE_ACCOUNT, {
    variables: {
      email,
      password,
    },
    context: { clientName: "auth-api" },
    onCompleted,
    onError,
  });

  return (
    <div className="settings-section delete-account">
      <div className="section-content">
        <HeaderBullet className="mb-[24px]">Delete your U.GG Account</HeaderBullet>
        <div className="deletion-info">
          <div className="deletion-info_header">{"Deleting your U.GG account will mean that:"}</div>
          <ul className="deletion-info_list">
            <li>{"All of your data will be deleted from our database in 72 hours."}</li>
            <li>{"Your League of Legends account will no longer be associated with this account."}</li>
            <li>{"You will not receive a refund for any remaining purchased U.GG Plus access."}</li>
            <li>
              If you are having issues deleting your account, please email us at{" "}
              <a className="underline" href="mailto:support@u.gg">
                support@u.gg
              </a>{" "}
              or contact us{" "}
              <strong style={{ cursor: "pointer", color: "white" }} onClick={toggleFeedbackPopup}>
                here
              </strong>
              .
            </li>
            {feedbackState && <FeedbackForm toggleFeedbackPopup={toggleFeedbackPopup} />}
          </ul>
        </div>
        {deleteError && formOpen && <div className="error-msg">{deleteError}</div>}
        {!formOpen ? (
          <div className="delete-account-btn btn-light-blue" onClick={() => setFormOpen(true)}>
            {"Delete My Account"}
          </div>
        ) : (
          <div className="delete-account-form">
            <div className="field-group">
              <div className="field-label">{"Email"}</div>
              <CustomInput
                value={email}
                error={emailError}
                onChange={(e) => setEmail(e.target.value)}
                tabIndex={100}
                type="text"
                autoFocus
              />
            </div>
            <div className="field-group">
              <div className="field-label">{"Password"}</div>
              <CustomInput
                value={password}
                error={passwordError}
                onChange={(e) => setPassword(e.target.value)}
                tabIndex={101}
                type="password"
              />
            </div>
            <div className="confirmation-btns">
              <ButtonSuccess className="confirm-btn btn-light-blue" label="Confirm" isLoading={loading} onClick={verifyForm} />
              <div className="cancel-btn btn-transparent" onClick={resetValues}>
                {"Cancel"}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeleteAccount;
